import unlimitedOption from '../constants/unlimitedOption';

const getValue = (
givenValue,
allowUnlimitedOption,
disableZero) =>
{
  if (givenValue === 0) {
    if (disableZero) {
      return allowUnlimitedOption ? unlimitedOption.value : 1;
    }
    return 0;
  }

  const defaultNotUnlimitedOption = disableZero ? 1 : 0;
  const defaultValue = allowUnlimitedOption ? unlimitedOption.value : defaultNotUnlimitedOption;

  return givenValue || defaultValue;
};

export default getValue;